(function () {
	var art = document.querySelector('.bb-hero__art');
	if (!art) return;

	var slides = Array.prototype.slice.call(art.querySelectorAll('.bb-hero__slide'));
	var dots = Array.prototype.slice.call(art.querySelectorAll('.bb-hero__dot'));
	if (slides.length < 2) return;

	var index = 0;
	var timer = null;
	var INTERVAL = 5000;
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function load(i) {
		var img = slides[i].querySelector('img[data-src]');
		if (img) {
			img.src = img.getAttribute('data-src');
			img.removeAttribute('data-src');
		}
	}

	function show(i) {
		index = (i + slides.length) % slides.length;
		load(index);
		load((index + 1) % slides.length);
		slides.forEach(function (slide, n) {
			slide.classList.toggle('is-active', n === index);
			slide.setAttribute('aria-hidden', n === index ? 'false' : 'true');
		});
		dots.forEach(function (dot, n) {
			dot.classList.toggle('is-active', n === index);
			dot.setAttribute('aria-current', n === index ? 'true' : 'false');
		});
	}

	function stop() {
		if (timer) {
			clearInterval(timer);
			timer = null;
		}
	}

	function start() {
		if (reduceMotion || timer) return;
		timer = setInterval(function () {
			show(index + 1);
		}, INTERVAL);
	}

	art.querySelector('.bb-hero__nav--prev').addEventListener('click', function () {
		show(index - 1);
		stop();
	});
	art.querySelector('.bb-hero__nav--next').addEventListener('click', function () {
		show(index + 1);
		stop();
	});
	dots.forEach(function (dot, n) {
		dot.addEventListener('click', function () {
			show(n);
			stop();
		});
	});

	art.addEventListener('mouseenter', stop);
	art.addEventListener('mouseleave', start);
	art.addEventListener('focusin', stop);

	// touch swipe
	var startX = null;
	art.addEventListener('touchstart', function (e) {
		startX = e.touches[0].clientX;
		stop();
	}, { passive: true });
	art.addEventListener('touchend', function (e) {
		if (startX === null) return;
		var dx = e.changedTouches[0].clientX - startX;
		if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
		startX = null;
	}, { passive: true });

	show(0);
	start();
})();
